import Lottie from 'lottie-react';

import electroJson from '../jsons/electrocardiogram-hover-pinch.json';

const ElectroCardio = props => {
  return <Lottie loop={false} animationData={electroJson} {...props} />;
};

export default ElectroCardio;
